(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  var useCache = 1;

  app.service('campaignApi', [
    '$http',
    '$q',
    function($http, $q) {

      this.getList = function(sort, search, page, io, campaignTypes, status, exHdl, advertisers, agencies, users) {
        var url = '/demandmgr/campaign/list';

        url = url + '?sortField=' + sort.field;
        url = url + '&sortOrder=' + sort.order;
        url = url + '&search=' + search;
        url = url + '&exHdl=' + exHdl;
        url = url + '&pageNumber=' + page.number;
        url = url + '&pageSize=' + page.size;
        url = url + '&useCache=' + useCache;
        if (advertisers && advertisers !== '*') {
            url = url + '&advertisers=' + advertisers.join(",");
        }
        if (agencies && agencies !== '*') {
            url = url + '&agencies=' + agencies.join(",");
        }
        if (users && users !== '*') {
            url = url + '&accmgrs=' + users.join(",");
        }
        if (io && io !== '*') {
          url = url + '&insertionOrder=' + io;
        }

        if (campaignTypes) {
            url = url + '&campaignTypes=' + encodeURIComponent(campaignTypes);
        }

        if (status) {
          url = url + '&status=' + status;
        }


          return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              console.log(res);
              reject();
            }
          );
        });
      };

        this.getActivityList = function(sort, search, page, io, status) {
            var url = '/demandmgr/campaign/activityList';

            url = url + '?sortField=' + sort.field;
            url = url + '&sortOrder=' + sort.order;
            url = url + '&search=' + search;
            url = url + '&pageNumber=' + page.number;
            url = url + '&pageSize=' + page.size;

            if (io && io !== '*') {
                url = url + '&insertionOrder=' + io;
            }

            if (status) {
                url = url + '&status=' + status;
            }


            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };


        this.getCampaignStat = function(campaign_list, start, end) {
        var url = '/reportsvwr/api?req=campaignDeliveryDaily&_f=json&groupBy=cid&useCache=1';
        if (campaign_list.length > 0) {
          url += '&campaignIds=' + campaign_list.join(',');
        }
        if (start){
            url += '&start=' + encodeURIComponent(start);
        }
        if (end){
              url += '&end=' + encodeURIComponent(end);
          }

          return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              console.log(res);
              reject();
            }
          );
        });
      };

        this.getCampaignStatToday = function(campaign_list,  start, end) {
            var url =
                '/reportsvwr/api?req=campaignDeliveryHourly&_f=json&groupBy=cid&today=1';
            if (campaign_list.length > 0) {
                url += '&campaignIds=' + campaign_list.join(',');
            }
            if (start){
                url += '&start=' + encodeURIComponent(start);
            }
            if (end){
                url += '&end=' + encodeURIComponent(end);
            }

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };


        this.getCampaignStatCDP = function(campaign_list) {
            var url =
                '/demandmgr/campaign/stats';
            if (campaign_list.length > 0) {
                url += '?campaignIds=' + campaign_list.join(',');
            }

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };


        this.getSummaryData = function(campaign_list, start_date, end_date) {
            var url =
                '/demandmgr/campaign/summaryData';
            if (campaign_list.length > 0) {
                url += '?cids=' + campaign_list.join(',');
            }
            if (start_date) {
                url += '&start_date=' + start_date;
            }
            if (end_date) {
                url += '&end_date=' + end_date;
            }


            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };
        this.getSummaryCreativesData = function(creatives_list, start_date, end_date) {
            var url =
                '/demandmgr/campaign/summaryCreativesData';
            if (creatives_list.length > 0) {
                url += '?aids=' + creatives_list.join(',');
            }
            if (start_date) {
                url += '&start_date=' + start_date;
            }
            if (end_date) {
                url += '&end_date=' + end_date;
            }


            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };

        this.getSummaryDailyData = function(campaign_list, start_date, end_date) {
            var url =
                '/demandmgr/campaign/summaryDailyData';
            if (campaign_list.length > 0) {
                url += '?cids=' + campaign_list.join(',');
            }
            if (start_date) {
                url += '&start_date=' + start_date;
            }
            if (end_date) {
                url += '&end_date=' + end_date;
            }

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    function(res) {
                        resolve(res.data);
                    },
                    function(res) {
                        console.log(res);
                        reject();
                    }
                );
            });
        };


        this.save = function(campaign) {
        var url = '/demandmgr/campaign/save';

        return $q(function(resolve, reject) {
          $http.post(url, campaign).then(
            // success
            function(res) {
                if (res.data.status === 'success') {
                    resolve(res.data.id);
                } else {
                    reject(res.data);
                }
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.delete = function(ioId) {
        var url = '/demandmgr/campaign?id=' + ioId;

        return $q(function(resolve, reject) {
          $http.delete(url).then(
            // success
            function(res) {
              resolve();
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.toggleActive = function(campaignIds) {
        var url = '/demandmgr/campaign/toggle-active?id=' + campaignIds;

        return $q(function(resolve, reject) {
          $http.put(url).then(
            // success
            function(res) {
              resolve();
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.read = function(campaignId) {
        var url = '/demandmgr/campaign/read?id=' + campaignId;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getInventory = function(search, dvt) {
        return $q(function(resolve, reject) {
          var url = '/demandmgr/campaign/inventory';

          url = url + '?search=' + search;

          if (dvt) {
            dvt.forEach(function(d) {
              url = url + '&dvt[]=' + d.value;
            });
          }

          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getInventoryClusters = function() {
        return $q(function(resolve, reject) {
          var url = '/demandmgr/campaign/inventory-clusters';
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

      this.getInventorySources = function(showAll) {
        return $q(function(resolve, reject) {
          var url = '/demandmgr/campaign/inventory-source';
          if (showAll !== undefined){
              url += '?showAll=' + (showAll ? '1' : '0');
          }

          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };

        this.getCreativeTypes = function() {
            return $q(function(resolve, reject) {
                var url = '/demandmgr/campaign/inventory-source';
                if (showAll !== undefined){
                    url += '?showAll=' + (showAll ? '1' : '0');
                }

                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

      this.getInventoryItems = function(source, clusters, search, dvt, adTypes) {
        return $q(function(resolve, reject) {
          var url = '/demandmgr/campaign/inventory-item';

          url = url + '?search=' + search;

          url = url + '&source=' + source;

          url = url + '&clusters=' + clusters;

          if (dvt) {
            dvt.forEach(function(d) {
              url = url + '&dvt[]=' + d.value;
            });
          }

           url = url + '&adTypes=' + adTypes;


            $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject();
            }
          );
        });
      };


        this.getLeadUrlPattern = function() {
            return $q(function(resolve, reject) {
                var url = '/demandmgr/campaign/leadUrlPattern';

                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

        this.getStatus = function(id, datetime) {
            return $q(function(resolve, reject) {
                var url = '/demandmgr/campaign/statusRead';
                url = url + '?id=' + id;
                url = url + '&dttm=' + datetime;

                $http.get(url).then(
                    // success
                    function(res) {
                      console.log(res);
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

        this.duplicate = id => {
            const url = '/demandmgr/campaign/duplicate';

            return $q((resolve, reject) => {
                $http.post(url, {id: id}).then(
                    res => {
                        resolve(res);
                    },
                    res => {
                        console.log(res);
                        reject(res);
                    }
                );
            });
        };

        this.duplicateCheck = id => {
            const url = '/demandmgr/campaign/duplicate';

            return $q((resolve, reject) => {
                $http.post(url, {id: id, check: 1}).then(
                    res => {
                        resolve(res);
                    },
                    res => {
                        console.log(res);
                        reject(res);
                    }
                );
            });
        };

      this.isCampaignNameUnique = function(
        advertiserId,
        campaignName,
        campaignId
      ) {
        var url =
          '/demandmgr/campaign/check-name?advertiserId=' +
          advertiserId +
          '&id=' +
          campaignId +
          '&name=' +
          campaignName;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
